import * as React from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import Keycloak from '../services/Keycloak';
import * as PubSub from 'pubsub-js';

export function Private(BaseComponent: any) {
class AuthenticatedComponent extends React.Component<RouteComponentProps<any>, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            ready: false
        }
    }

    public componentWillMount() {
        this.checkAuthentication(this.props);
        PubSub.subscribe('AUTH', (msg: any, data: any) => {
            this.setState({ready: true})
        });
    }

    public componentWillReceiveProps(nextProps: any) {
        if (nextProps.location !== this.props.location) {
            this.checkAuthentication(nextProps);
        }
    }

    public checkAuthentication(params: any) {
        if (!sessionStorage.getItem('token') || sessionStorage.getItem('token') === "") {
            new Keycloak().getInstance().login();
        } else {
            this.setState({ready: true});
        }
    }

    public render() {
        return !this.state.ready ? <div/> :
        <BaseComponent {...this.props} />;
    }
}

return withRouter(AuthenticatedComponent);
}



// WEBPACK FOOTER //
// ./src/services/PrivateRoute.tsx